module.exports = __webpack_public_path__ + "img/wzsc.99d9d298.svg";